import React from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";

class ThemMoiNhanVien extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text1: "",
    };
  }
  onChangeData = (field, event) => {
    let state = this.state;
    state[field] = event.target.value;
    this.setState(state);
  };

  render() {
    let props = this.props;

    return (
      <Modal
        {...props}
        size="modal-new-size modal-new-size"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left popup-detail"
      >
        <Modal.Header>
          <h4 className="modal-title" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="fas fa-plus"></i>
            </span>{" "}
            Thêm mới
          </h4>
          <button
            type="button"
            className="close-popup-new"
            data-dismiss="modal"
            aria-label="Close"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <form class="form tat-toan form-horizontal ">
            <div class="form-body">
              <div class="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse253"
                  class="card-header border-info"
                  href="#collapse253"
                  aria-expanded="true"
                  aria-controls="collapse253"
                >
                  <a href={() => false} class="card-title lead info collapsed">
                    <h3>Tài khoản đăng nhập</h3>
                  </a>
                </div>
                <div
                  id="collapse253"
                  aria-labelledby="headingCollapse253"
                  class="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div class="card-content">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Email đăng nhập"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Mật khẩu"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Xác nhận mật khẩu"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Quyền</label>
                            <select class="selectBox form-control input-sm">
                              <option value="0">Chủ</option>
                              <option value="1">Quản lý</option>
                              <option value="2">Nhân viên</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Cửa hàng</label>
                            <select class="selectBox form-control input-sm">
                              <option value="0">Cửa hàng 1</option>
                              <option value="1">Cửa hàng 2</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  id="headingCollapse553"
                  class="card-header border-info mt-1"
                  href="#collapse553"
                  aria-expanded="true"
                  aria-controls="collapse553"
                >
                  <a href={() => false} class="card-title lead info collapsed">
                    <h3>Thông tin cá nhân</h3>
                  </a>
                </div>
                <div
                  id="collapse553"
                  aria-labelledby="headingCollapse553"
                  class="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div class="card-content">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Họ Tên"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Giới tính</label>
                            <select class="selectBox form-control input-sm">
                              <option value="0">Nam</option>
                              <option value="1">Nữ</option>
                            </select>
                          </div>
                        </div>

                        <div class="col-md-3">
                          <div class="form-group">
                            <label>Ngày sinh</label>
                            <input
                              type="text"
                              id="userinput1"
                              class="form-control input-sm"
                            />
                          </div>
                        </div>

                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Số CCCD"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Địa chỉ"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Số điện thoại"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Email đăng nhập"
                          ></TextInputOnRow>
                        </div>

                        <div class="col-md-3">
                          <TextInputOnRow
                            labelClass="label-control"
                            inputClass="form-control input-sm"
                            wrapperClass="form-group"
                            labelText="Mã nhân viên"
                            disabled="disabled"
                          ></TextInputOnRow>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <a className="btn btn-new-main btn-checknew" href={() => false}>
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>{" "}
            Thêm mới
          </a>

          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ThemMoiNhanVien;
